import { Button, TextArea, TextInput } from '@ibinder/common-frontend';
import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
  min-height: 350px;
  background: ${({ theme }) => theme.colors.accent};
  box-shadow: ${({ theme }) => theme.shadows.primaryWithOpacity};
  padding: 1rem;
  position: fixed;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);

  button {
    margin-top: auto;
  }
`;

const FieldContainer = styled.div`
  margin-bottom: 1rem;
`;

const ErrorText = styled.div`
  color: red;
  margin-bottom: 1rem;
`;

type Ref = HTMLDivElement;

type Props = {
  title: string;
  btnLabel: string;
  onClick: (reason: string, supportCase?: string) => void;
};

const ActionBarModal = forwardRef<Ref, Props>(
  ({ title, onClick, btnLabel }, ref) => {
    const [reason, setReason] = useState('');
    const [supportCase, setSupportCase] = useState('');
    const [showRequiredError, setShowRequiredError] = useState(false);

    const getInputValue = (value) => value?.target?.value ?? value;

    const handleClick = () => {
      if (!reason.trim()) {
        setShowRequiredError(true);
        return;
      }

      onClick(reason.trim(), supportCase.trim() || undefined);
    };

    return (
      <Container ref={ref}>
        <h2>{title}</h2>
        <FieldContainer>
          <TextArea
            label="Reason"
            value={reason}
            changeValue={(value) => {
              setReason(getInputValue(value));
              setShowRequiredError(false);
            }}
            required={true}
          />
        </FieldContainer>
        <FieldContainer>
          <TextInput
            label="Support case"
            value={supportCase}
            changeValue={(value) => setSupportCase(getInputValue(value))}
          />
        </FieldContainer>
        {showRequiredError && <ErrorText>Reason is required</ErrorText>}
        <Button btnStyle="primary" label={btnLabel} onClick={handleClick} />
      </Container>
    );
  }
);

export default ActionBarModal;
